import { getCells, PLANT_FAMILIES } from './pieces';
import { BOARD_HEIGHT, BOARD_WIDTH, type ActivePiece, type Board, type Cell } from './types';

export function createBoard(): Board {
  return Array.from({ length: BOARD_HEIGHT }, () => Array<Cell | null>(BOARD_WIDTH).fill(null));
}

export function cloneBoard(board: Board): Board {
  return board.map((row) => [...row]);
}

export function isValidPosition(board: Board, piece: ActivePiece): boolean {
  return getCells(piece.type, piece.rotation).every(({ x, y }) => {
    const boardX = piece.x + x;
    const boardY = piece.y + y;
    return (
      boardX >= 0 &&
      boardX < BOARD_WIDTH &&
      boardY >= 0 &&
      boardY < BOARD_HEIGHT &&
      board[boardY]?.[boardX] === null
    );
  });
}

export function mergePiece(board: Board, piece: ActivePiece): Board {
  const next = cloneBoard(board);
  const cell: Cell = { piece: piece.type, family: PLANT_FAMILIES[piece.type] };
  for (const { x, y } of getCells(piece.type, piece.rotation)) {
    const row = next[piece.y + y];
    if (row) row[piece.x + x] = cell;
  }
  return next;
}

export function clearCompletedRows(board: Board): { board: Board; rows: number[] } {
  const rows: number[] = [];
  const remaining = board.filter((row, index) => {
    const complete = row.every(Boolean);
    if (complete) rows.push(index);
    return !complete;
  });
  const emptyRows = Array.from({ length: rows.length }, () =>
    Array<Cell | null>(BOARD_WIDTH).fill(null),
  );
  return { board: [...emptyRows, ...remaining.map((row) => [...row])], rows };
}

export function clearSelectedRow(board: Board, rowIndex: number): Board | null {
  if (rowIndex < 0 || rowIndex >= BOARD_HEIGHT || !board[rowIndex]?.some(Boolean)) return null;
  const next = board.filter((_, index) => index !== rowIndex).map((row) => [...row]);
  next.unshift(Array<Cell | null>(BOARD_WIDTH).fill(null));
  return next;
}
